import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import config from '../../config';
import { twitterPageURL } from '../../util/urlHelpers';
import { StaticPage, TopbarContainer } from '../../containers';
import {
  LayoutSingleColumn,
  LayoutWrapperTopbar,
  LayoutWrapperMain,
  LayoutWrapperFooter,
  Footer,
} from '../../components';
import './BlogMainPage.css';

// Import images
import image1 from './background-1440.jpg';
import image2 from './auger.jpg';
import image3 from './background-1441.jpg';
import image4 from './background-1442.jpg';
import image5 from './PWasher.jpg';
//import image4 from './background-1443.jpg';

const BlogMainPage = () => {
  const { siteTwitterHandle, siteFacebookPage } = config;
  const siteTwitterPage = twitterPageURL(siteTwitterHandle);
  const [blogs, setBlogs] = useState([]);

  useEffect(() => {
    // Fetch blogs from API and set them to state
    // This is a placeholder and should be replaced with actual API call
    setBlogs([
      {
        title: 'Monetizing Your Idle Tools',
        excerpt:
          'Learn how you can earn money from your idle tools by renting them out on Lenddit.',
        image: image1,
        link: '/blog-Monetize-Your-Idle-Tools',
      },
      {
        title: 'Pressure Washer: Cash in on Cleaning',
        excerpt: 'Turn Your Pressure Washer into a Money-Making Machine with Lenddit',
        image: image5,
        link: '/blog-pressure-washer',
      },
      {
        title: 'Potential of Your Auger with Lenddit',
        excerpt: 'Renting out your auger can be a significant source of income.',
        image: image2,
        link: '/blog-auger',
      },
      {
        title: 'Power of Reviews',
        excerpt:
          'Discover how reviews can help build trust and credibility for your Lenddit listings.',
        image: image3,
        link: '/blog-power-of-reviews',
      },
      {
        title: 'Rent My Equipment',
        excerpt:
          'Lenddit turns "rent my tools" into a profitable venture, aiding income generation, and fostering local connections.',
        image: image4,
        link: '/blog-rent-my-equipment',
      },
      /*{ 
        title: 'I love April', 
        excerpt: 'Fourteen cows jumped over the moon', 
        image: image4, 
        link: '/blog4' 
      },*/
    ]);
  }, []);

  return (
    <StaticPage
      title="Blog"
      schema={{
        '@context': 'http://schema.org',
        '@type': 'BlogPage',
        description: 'Blog',
        name: 'Blog',
      }}
    >
      <LayoutSingleColumn>
        <LayoutWrapperTopbar>
          <TopbarContainer />
        </LayoutWrapperTopbar>
        <LayoutWrapperMain>
          <div className="BlogMainPage">
            <div className="introSection">
              <h1>Lenddit's Blog</h1>
              <h2>
                Explore Lenddit's Blog to gain valuable insights into the world of peer-to-peer
                lending. From tips on maximizing your earnings to understanding the lending
                landscape, our blog equips you with the knowledge you need to make informed
                decisions.
              </h2>
            </div>
            <div className="grid-container">
              {blogs.map((blog, index) => (
                <div className={`grid-item grid-item-${index + 1}`} key={index}>
                  <Link to={blog.link}>
                    <img src={blog.image} alt={blog.title} />
                    <h2>{blog.title}</h2>
                  </Link>
                  <p>{blog.excerpt}</p>
                </div>
              ))}
            </div>
          </div>
        </LayoutWrapperMain>
        <LayoutWrapperFooter>
          <Footer />
        </LayoutWrapperFooter>
      </LayoutSingleColumn>
    </StaticPage>
  );
};

export default BlogMainPage;
